module.exports = __webpack_public_path__ + "img/edu-tablet.709af4b.jpg";